import createValueModule from "@/redux/create-value-module";

import {
    $ProductComparisonSkuListModuleName,
    TProductComparisonSkuListState
} from "./productComparisonSkuList.types";

const { constants: _constants, actions } =
    createValueModule<TProductComparisonSkuListState>(
        $ProductComparisonSkuListModuleName,
        []
    );

export const clear = actions.clear;
export const set = actions.set;
export const update = actions.update;

export const constants = _constants;
